import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Popover, Overlay } from 'react-bootstrap'
import ArrayUtil from '@leverege/array-util'

import TimelineValue from './TimelineValue'
import KeyframeEditor from './KeyframeEditor'
import InterpolatorView from './InterpolatorView'
import InterpolatorEditor from './InterpolatorEditor'
import style from './style.css'

export default class TimelineView extends React.Component {
  
  static propTypes = {
    timeCalc : PropTypes.object,
    timeline : PropTypes.object,
    onChangeKeyframeTime : PropTypes.func.isRequired,
    onCreateKeyframe : PropTypes.func
  }
  
  constructor( props ) {
    super( props )
    this.state = { showKeyFrameEditor : false, showInterpolatorEditor : false }
  }

  onClick = ( evt ) => {
    const { timeCalc } = this.props
    const x = timeCalc.discreteX( timeCalc.xFromEvent( evt ) )
    const t = timeCalc.xToTime( x )

    const y = timeCalc.yFromEvent( evt )
    if ( y > timeCalc.rootView.offsetHeight || timeCalc.inPopover( evt ) ) {
      return
    }

    const state = { showKeyFrameEditor : true, keyframe : null, time : t, point : { x, y : 0 } }

    // Delay this because the overlay root wrapper will hide the dialog
    setTimeout( () => { this.setState( state ) }, 1 )
  }

  onCancel = () => {
    this.setState( { showKeyFrameEditor : false, showInterpolatorEditor : false } )
  }

  onRemove = ( evt ) => {
    if ( this.props.onRemoveKeyframe ) {
      this.props.onRemoveKeyframe( evt )
    }
    this.setState( { showKeyFrameEditor : false } )
  }

  onValueClicked = ( evt ) => {
    const state = { showKeyFrameEditor : true,
                    showInterpolatorEditor : false, 
                    keyframe : evt.keyframe,
                    time : evt.keyframe.time,
                    point : { x : evt.x, y : 0 } }
    setTimeout( () => { this.setState( state ) }, 1 )
  }

  onInterpolatorClicked = ( evt ) => {
    const { timeCalc } = this.props
    const x = timeCalc.discreteX( timeCalc.xFromEvent( evt.event ) )
    const t = timeCalc.xToTime( x )

    const state = { showInterpolatorEditor : true,
                    showKeyFrameEditor : false,
                    time : t,
                    keyframe : evt.keyframe,
                    point : { x : evt.x, y : 0 } }
    setTimeout( () => { this.setState( state ) }, 1 )
  }

  onSwitchToKeyframe = ( evt ) => {

    const state = { showKeyFrameEditor : false, showInterpolatorEditor : false, keyframe : null }
    this.setState( state, function( ) { 
      this.setState( { showKeyFrameEditor : true } )
    } )
  }

  onCreateKeyframe = ( evt ) => {
    if ( this.props.onCreateKeyframe ) {
      this.props.onCreateKeyframe( evt )
    }
    this.setState( { showKeyFrameEditor : false } )
  }

  onChangeInterpolator = ( evt ) => {
    if ( this.props.onChangeInterpolator ) {
      this.props.onChangeInterpolator( evt )
    }
    this.setState( { showInterpolatorEditor : true }, function() {
      this.setState( { showInterpolatorEditor : true } )
    } )

  }
  
  render() {
    const { scale, maxTime, attribute, timeline, timeCalc, onChangeKeyframeTime } = this.props
    const { time, point, showKeyFrameEditor, showInterpolatorEditor, keyframe } = this.state

    const cells = []
    const keyframes = timeline.keyframes || []
    for ( let n = 0; n < keyframes.length; n++ ) {
      const kf = keyframes[n]
      if ( n + 1 < keyframes.length ) {
        cells.push( <InterpolatorView key={`i-${kf.id}`}
          timeCalc={timeCalc}
          timeline={timeline}
          kf1={kf}
          kf2={keyframes[n + 1]}
          onInterpolatorClicked={this.onInterpolatorClicked} /> )
      }
      cells.push( <TimelineValue key={keyframes[n].id}
        keyframe={kf}
        timeline={timeline}
        timeCalc={timeCalc}
        onValueClicked={this.onValueClicked}
        onTimeChangeRequest={onChangeKeyframeTime} /> )

    }

    let createDialog
    if ( showKeyFrameEditor || showInterpolatorEditor ) {
      const currentKeyframe = keyframe && ArrayUtil.find( keyframes, 'id', keyframe.id )
      let popover
      const pt = (
        <div key="1"
          ref={( elem ) => { this.newTarget = elem }} 
          className={classnames( style.timelineValue, style.create )} 
          style={{ left : `${point.x}px` }}>
          <i className="fa fa-plus" />

        </div>
      )
      if ( showKeyFrameEditor ) {
        popover = (
          <Popover
            className={classnames( style.popover, style.win )}
            placement="top"
            id={attribute.path}
            title={keyframe != null ? 'Edit Keyframe' : 'Create Keyframe'}>
            <KeyframeEditor 
              attribute={attribute} 
              keyframe={currentKeyframe}
              timeline={timeline}
              time={time} // needed for new keyframes
              onSet={this.onCreateKeyframe}
              onCancel={this.onCancel}
              onRemove={this.onRemove} />
          </Popover>
        )
      } else {
        popover = (
          <Popover className={style.popover} placement="top" id={attribute.path} title="Edit Interpolator">
            <InterpolatorEditor
              attribute={attribute}
              timeline={timeline}
              keyframe={currentKeyframe}
              onChange={this.onChangeInterpolator}
              onSwitchToKeyframe={this.onSwitchToKeyframe}
              onCancel={this.onCancel} />
          </Popover>
        )
      }
      createDialog = [ pt,
        (
          <Overlay show
            shouldUpdatePosition
            onHide={( e ) => { this.setState( { showKeyFrameEditor : false, showInterpolatorEditor : false } ) }}
            key={`cf-${attribute.path}`}
            rootClose
            placement="top"
            target={() => this.newTarget}>
            {popover}
          </Overlay>
        )
      ]
    }

    return (
      <div ref={( e ) => { this.element = e; }} className={style.timelineView} onClick={this.onClick}>
        {cells}
        {createDialog}
      </div>
    )
  }
}
